import React from "react";
import GeneralService from "../services/general-service";
import ManagementService from "../services/management-service";
import { validatePassword } from "./validate-helper";

export const getEmployeeData = (employee?: Employee) => {
  const data: EmployeeFormData = {
    formData: {
      name: employee?.name || null,
      email: employee?.email || null,
      password: employee?.password || null,
      role: employee?.role || null,
    },
    classData: [],
  };

  return data;
};

// On edit a blank password means "keep the current one" — updateEmployee strips falsy fields before
// the PATCH, and the API only validates a password it actually receives.
const isPasswordAcceptable = (password: string, isEdit: boolean) => {
  if (!password) return isEdit;

  return validatePassword(password).isValid;
};

export const checkIfAllFormHasFilled = (
  data: EmployeeFormData,
  validations: object,
  allowSubmit: boolean,
  setAllowSubmit: React.Dispatch<React.SetStateAction<boolean>>,
  isEdit: boolean = false
) => {
  if (
    data &&
    data.formData &&
    data.formData.name &&
    data.formData.email &&
    data.formData.role &&
    isPasswordAcceptable(data.formData.password, isEdit) &&
    data.classData.length > 0 &&
    Object.keys(validations).length === 0
  ) {
    setAllowSubmit(true);
  } else if (allowSubmit) {
    setAllowSubmit(false);
  }
};

export const handleStudentChange = (
  selectedClassrooms: number[],
  selectedStudents: number[],
  data: EmployeeFormData,
  setData: React.Dispatch<React.SetStateAction<EmployeeFormData>>
) => {
  const newData = {
    formData: { ...data.formData },
    classData: selectedClassrooms,
    studentData: selectedStudents,
  };

  setData(newData);
};

export const handleFormOnChange = async (
  e: React.ChangeEvent<
    HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
  >,
  validations: object,
  data: EmployeeFormData,
  setValidations: (value: React.SetStateAction<{}>) => any,
  setData: (value: React.SetStateAction<EmployeeFormData>) => any,
  isEdit: boolean = false,
) => {
  const generalService = new GeneralService();
  const id = e.target.id;
  let value = e.target.value;
  const type = e.target.type;
  const eventType = e.type;

  const newValidations = Object.assign({}, validations);

  if (id === 'password') {
    // No message of its own: the checklist below the field already names every unmet rule, and an
    // incomplete password keeps the submit button disabled. The entry is only ever set from a
    // rejected save, so typing clears whatever the API last complained about.
    delete newValidations[id];
  } else if (!value && id !== 'attachment' && id !== 'image') {
    newValidations[id] = 'Campo obrigatório.';
  } else if (id !== 'attachment' && id !== 'image') {
    delete newValidations[id];
  }

  const newData = Object.assign({}, data);
  if (type !== 'file') {
    newData.formData[id] = value;
  }

  setValidations(newValidations);
  setData(newData);
};

export const deleteEmployee = (
  employeeId: number,
  setModalContent: (content: ModalContent) => any,
  setToastContent: (content: ToastContent) => void,
  navigate: any
) => {
  const managementService = new ManagementService();
  setModalContent({
    title: 'Deletar funcionário',
    modalContent: React.createElement(
      'p',
      null,
      'Deseja realmente deletar o funcionário?'
    ),
    submitButtonTitle: 'confirmar deleção',
    submitButtonType: 'primary',
    submitData: null,
    onSubmitButtonClick: () =>
      managementService
        .deleteEmployee(employeeId)
        .then(() => {
          setToastContent({
            isOpen: true,
            text: 'funcionário deletado!',
            type: 'success',
          });
          navigate('/gerenciar');
        })
        .catch(() => {
          setToastContent({
            isOpen: true,
            text: 'Houve um erro ao deletar o funcionário.',
            type: 'error',
          });
        }),
    isOpen: true,
  });
};
